import { Pipe, PipeTransform } from "@angular/core";
import { IWithStockObject } from "../../models";

/**
 * Filtert Elemente ob sie ein Stock-Objekt haben
 */
@Pipe({
    name: 'hasStockObject',
    pure: false
})
export class HasStockObjectPipe implements PipeTransform {
    /**
     * Elemente müssen ein Stock-Objekt aufweisen
     * @param items 
     * @returns 
     */
    transform(items: IWithStockObject[]): any {
        return items.filter(item => item?.stock_object);
    }
}